import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private profileSavedSource = new Subject<void>();
  profileSaved$ = this.profileSavedSource.asObservable();

  constructor() { }

  notifyProfileSaved(): void {
    this.profileSavedSource.next();
  }
}
